import styled, { ITheme } from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const Label = styled.span<IWithSize>`
  @media (min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    font-size: ${({ size }) => (size ? 22 * size : 22)}px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  }

  font-family: Montserrat;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
`

export default Label
